import moment from 'moment';

import constants from '../../ahm-constants';

// Calculates a date of birth from an age value, bounds the result between 1900-01-01 and today.
const getDateOfBirthFromAge = (age: number | string): string => {
  // This needs to be done as api response can mistake todays date as not being 18.
  const guessedAge = moment().subtract(age, 'years').subtract(1, 'months');

  const lowerBounded = moment.max(moment('1900-01-01'), guessedAge);
  const upperBounded = moment.min(lowerBounded, moment());

  return upperBounded.format(constants.DATE_FORMAT.STANDARD);
};

export default getDateOfBirthFromAge;
